<template>
	<MobileLayout>
		<div class="mobile-home-page">
			<section class="m-hero">
				<!-- 1. 全屏背景图 -->
				<img :src="heroImage" alt="denHolm" class="hero-bg" />
				
				<!-- 2. Logo 渐变背景层 -->
				<div class="logo-bg-layer"></div>

				<!-- 3. 顶部 Logo -->
				<div class="m-hero-overlay">
					<div class="m-hero-logo">
						<img src="@/assets/mobile/home/logo.png" alt="denHolm" class="logo" />
					</div>
				</div>
			</section>
		</div>
	</MobileLayout>
</template>

<script>
	import MobileLayout from '@/components/mobile/MobileLayout.vue'
	import { getUser } from '@/config/auth'

	const heroImage = require('@/assets/mobile/home/bg.png')

	export default {
		name: 'MobileHome',
		components: { MobileLayout },
		data() {
			return {
				heroImage,
				autoPopupTimer: null
			}
		},
		mounted() {
			// ★ 页面加载完成，通知 MobileLayout 显示内容（淡入）
			this.$nextTick(() => {
				window.dispatchEvent(new CustomEvent('page-ready'))
			})

			document.body.style.overflow = 'hidden'
			document.documentElement.style.overflow = 'hidden'
			document.addEventListener('touchmove', this.preventTouchMove, { passive: false })
			this.scheduleAutoPopup()
		},
		beforeDestroy() {
			if (this.autoPopupTimer) clearTimeout(this.autoPopupTimer)
			document.body.style.overflow = ''
			document.documentElement.style.overflow = ''
			document.removeEventListener('touchmove', this.preventTouchMove)
		},
		methods: {
			preventTouchMove(e) {
				if (e.target.closest('.m-drawer') || e.target.closest('.m-sheet')) {
					return
				}
				e.preventDefault()
			},
			isLoggedInAndSubscribed() {
				const user = getUser()
				return !!(user && user.IsSubscribed === true)
			},
			scheduleAutoPopup() {
				if (this.autoPopupTimer) clearTimeout(this.autoPopupTimer)
				const delay = 5000
				const hasAutoShown = localStorage.getItem('emailAutoShown') === 'true'
				if (hasAutoShown) return
				if (this.isLoggedInAndSubscribed()) return

				this.autoPopupTimer = setTimeout(() => {
					if (this.isLoggedInAndSubscribed()) return
					if (localStorage.getItem('emailAutoShown') === 'true') return
					window.dispatchEvent(new CustomEvent('open-auto-email-popup'))
					this.autoPopupTimer = null
				}, delay)
			}
		}
	}
</script>

<style scoped>
	.mobile-home-page {
		height: 100vh;
		overflow: hidden;
		position: relative;
	}

	.m-hero {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		height: 100dvh;
		overflow: hidden;
	}

	.hero-bg {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
		display: block;
		z-index: 0;
	}

	.logo-bg-layer {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 92rem;
		background: linear-gradient(180deg, rgba(0, 0, 0, 0.34) 0%, rgba(217, 217, 217, 0) 100%);
		z-index: 1;
		pointer-events: none;
	}

	.m-hero-overlay {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: flex-start;
		justify-content: center;
		pointer-events: none;
		z-index: 2;
	}

	.m-hero-logo {
		width: 100%;
		text-align: center;
	}

	.logo {
		width: 100%;
		height: auto;
		display: block;
		padding-top: 5rem;
	}
</style>